export default __webpack_public_path__ + "static/media/Code.1568d458.otf";